import {api} from './api';

export interface IdpayAtivaResponse {
  ativa_unico: boolean;
}

export async function verificarIdpayAtiva(): Promise<IdpayAtivaResponse> {
  const {data} = await api.get<IdpayAtivaResponse>('/payments/idpay/ativa');
  return data;
}

export interface CompraPendenteIdpay {
  _id: {
    $oid: string;
  };
  tipo_operacao: string;
  idpay_transaction_id: string;
  idpay_status: string;
  idpay_link: string;
  idpay_expires_at: string;
}

export interface IdpayPendentesResponse {
  compras: CompraPendenteIdpay[];
}

export async function listarPendentesIdpay(): Promise<IdpayPendentesResponse> {
  const {data} = await api.get<IdpayPendentesResponse>('/payments/idpay/pendentes');
  return data;
}

export interface IdpayStatusResponse {
  success: boolean;
  status: string;
  approved: boolean;
  pending: boolean;
  manual_review: boolean;
}

export async function consultarStatusIdpay(
  compraId: string,
): Promise<IdpayStatusResponse> {
  const {data} = await api.get<IdpayStatusResponse>(
    `/payments/${compraId}/idpay/status`,
  );
  return data;
}
